<template>
    <div class="rewards-page" style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <!-- Back Button & Title -->
            <div class="header">
                <CButton class="back-button" @click="$router.go(-1)">
                    ←
                </CButton>
    
                <h2 class="page-title">Rewards</h2>
            </div>
    
            <!-- Tab Switcher -->
            <div class="tab-switch mt-5">
                <button :class="{ active: activeTab === 'claim' }" @click="activeTab = 'claim'">
                Claim
              </button>
                <button :class="{ active: activeTab === 'your-rewards' }" @click="activeTab = 'your-rewards'">
                Your Rewards
              </button>
            </div>
    
            <!-- Claim Your Rewards Section -->
            <div v-if="activeTab === 'claim'">
                <h3 class="section-title">Claim Your Rewards</h3>
                <div class="rewards-list">
                    <div v-for="reward in claimRewards" :key="reward.id" class="reward-card" :style="{ backgroundImage: `url(${reward.image})` }">
                        <div class="reward-info">
                            <h4>{{ reward.title }}</h4>
                            <p v-html="reward.description"></p>
                        </div>
                        <div class="reward-footer">
                            <span class="points-badge">💰 {{ reward.points }}</span>
                            <CButton class="claim-btn" @click="openPopup()">Claim</CButton>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- Your Rewards Section -->
            <div v-if="activeTab === 'your-rewards'">
                <h3 class="section-title">Your Rewards</h3>
                <div class="rewards-list">
                    <div v-for="reward in yourRewards" :key="reward.id" class="reward-card" :style="{ backgroundImage: `url(${reward.image})` }">
                        <div class="reward-info">
                            <h4>{{ reward.title }}</h4>
                            <p v-html="reward.description"></p>
                        </div>
                        <div class="reward-footer">
                            <span class="points-badge">💰 {{ reward.points }}</span>
                            <CButton  @click="showDetail" class="status-btn" :class="{ expired: reward.status === 'expired' }">
                                {{ reward.status === "expired" ? "Expired" : "Claimed" }}
                            </CButton>
                        </div>
                    </div>
                </div>
            </div>
    
            <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <img src="../assets/img/new/fore.png" style="max-width:100%"/>
                    <h2 class="font-color-171717 custom-20px-600">Get 1 free tall espresso, cappuccino or latte in any BRAND A.</h2>
    
                    <p class="cta-text">Start collecting now and get rewarded!</p>
                    <button class="ok-button half-border" @click="showSuccess">Redeem For 100 Points</button>
                    <h3 class="custom-14px-500 mt-2">Available Points : 500</h3>
                </div>
            </div>
            <div v-if="showPopupSuccessClaim" class="popup-overlay" @click.self="closePopupSuccess">
                <div class="popup-content">
                    <img src="../assets/img/new/successpurple.png" style="max-width:100%"/>
                    <h2 class="font-color-171717 custom-20px-600">🎉 Reward Redeemed!</h2>
    
                    <p class="cta-text font-color-6C737F">You've successfully redeemed 1 free tall espresso, cappuccino, or latte at BrandA! ☕✨</p>
                    <button class="ok-button half-border" @click="showDetail">Continue</button>
                </div>
            </div>
            <div v-if="showPopupDetailClaim" class="popup-overlay" @click.self="closePopupDetail">
                <div class="popup-content">
                    <img src="../assets/img/new/fore.png" style="max-width:100%"/>
                    <h2 class="font-color-9DA4AE custom-14px-500 text-left">Voucher</h2>
                    <p class="custom-14px-600 text-left">Free Coffee at Brand A</p>

                    <p class="custom-14px-600 text-left mt-2">How to get?</p>
                    <ol class="text-left">
                        <li class="text-left">Come to any Brand A</li>
                        <li class="text-left">Show the barcode to the waiter</li>
                        <li class="text-left">Get 1 free tall espresso, cappuccino, or latte in any Brand A.</li>
                    </ol>
    
                    <img src="../assets/img/new/qr.png" style="max-width:150px"/>
                    <h3 class="custom-12px-400 mt-2">Expired: <i class="font-color-9DA4AE">30 November 2025</i></h3>
                    <button class="ok-button half-border mt-3" @click="closePopupDetail">Ok</button>
                </div>
            </div>
        </CContainer>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            activeTab: "claim",
            claimRewards: [{
                    id: 1,
                    title: "Beauty Product Discount",
                    description: "Get A Discount Voucher Up To <b>50%!</b>Help us by answering a short survey and enjoy a discou",
                    points: 100,
                    image: require("@/assets/img/new/claim1.png"),
                },
                {
                    id: 2,
                    title: "Cashback For Online Shopping",
                    description: "Complete The Survey, Get <b>30%</b> Cashback!We want to hear your opinion! Complete this survey and enjoy up to 30% cashback for shopping at ShopEase.",
                    points: 100,
                    image: require("@/assets/img/new/claim2.png"),
                },
                {
                    id: 3,
                    title: "Food & Beverage Promo",
                    description: "<b>40%</b> Discount Voucher for Every Order!Help us improve our services by answering this survey and receive a special discount for your next order.",
                    points: 100,
                    image: require("@/assets/img/new/claim3.png"),
                },
            ],
            yourRewards: [{
                    id: 1,
                    title: "Beauty Product Discount",
                    description: "Get A Discount Voucher Up To <b>50%!</b>",
                    points: 100,
                    image: require("@/assets/img/new/claim3.png"),
                    status: "claimed",
                },
                {
                    id: 2,
                    title: "Beauty Product Discount",
                    description: "Get A Discount Voucher Up To <b>50%!</b>",
                    points: 100,
                    image: require("@/assets/img/new/claim3.png"),
                    status: "expired",
                },
            ],
            showPopup: false,
            showPopupSuccessClaim:false,
            showPopupDetailClaim:false
        };
    },
    methods: {
        openPopup(item) {
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;
        },
        showSuccess()
        {
            this.showPopup = false;
            this.showPopupSuccessClaim = true;
        },
        showDetail()
        {
            this.showPopupSuccessClaim = false;
            this.showPopupDetailClaim = true;
        },
        closePopupDetail()
        {
            this.showPopupDetailClaim = false;

        }


    }
};
</script>
  
<style scoped>
/* Page Styling */

.rewards-page {
    background-color: #f8f8f8;
    padding: 20px;
}

/* Header */

.header {
    display: flex;
    align-items: center;
    position: relative;
}

.back-button {
    position: absolute;
    left: 0;
}

.page-title {
    text-align: center;
    flex: 1;
    font-size: 20px;
    font-weight: bold;
}

/* Tab Switcher */

.tab-switch {
    display: flex;
    justify-content: center;
    margin: 15px;
    border-radius: 40px;
    border: 1px solid var(--Grayscale-200, #E5E7EB);
    background: var(--Grayscale-50, #F9FAFB);
    padding: 5px;
}

.tab-switch button {
    flex: 1;
    padding: 10px;
    border: none;
    background: var(--Grayscale-50, #F9FAFB);
    font-size: 16px;
    cursor: pointer;
    border-radius: 25px;
}

.tab-switch button.active {
    background: #a588f4;
    color: white;
}

/* Rewards List */

.rewards-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* Reward Card */

.reward-card {
    background-size: cover;
    background-position: center;
    color: white;
    border-radius: 15px;
    padding: 15px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 140px;
}

/* Gradient Overlay */

.reward-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8));
    border-radius: 15px;
    z-index: 0;
}

.reward-info {
    position: relative;
    z-index: 1;
}

.reward-info h4 {
    font-size: 16px;
    font-weight: bold;
}

.reward-info p {
    font-size: 14px;
}

/* Footer */

.reward-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
}

.points-badge {
    background: rgba(0, 0, 0, 0.6);
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 14px;
}

/* Buttons */

.claim-btn,
.status-btn {
    background: white;
    color: black;
    border-radius: 20px;
    padding: 6px 12px;
    font-size: 14px;
}

.status-btn.expired {
    background: #ff5a5a;
    color: white;
}
</style>